module.exports = __webpack_public_path__ + "static/media/email-verification.49dd8536.png";